import React from 'react';

export type TenantPublicConfig = {
    tenant: string;
    name: string;
    baseUrl: string;
    businessTypes: string[];
    animalTypes: string[];
    auth: { provider: string; domain: string; clientId: string; audience?: string };
    ui?: { website?: string, logoUrl?: string; primaryColor?: string, homeRulesUrl?: string; vaccinationsUrl?: string, email?: string, phone?: string };
};

type Ctx = { cfg: TenantPublicConfig };
const TenantConfigContext = React.createContext(null);

export function useTenantConfig() {
    const ctx = React.useContext(TenantConfigContext);
    if (!ctx) throw new Error('useTenantConfig must be used within <TenantConfigProvider>');
    return ctx;
}

export function TenantConfigProvider({ cfg, children }: { cfg: TenantPublicConfig; children: React.ReactNode }) {
    // value is stable as long as cfg reference is the same
    const value = React.useMemo(() => ({ cfg }), [cfg]);
    return <TenantConfigContext.Provider value={value}>{children}</TenantConfigContext.Provider>;
}
